module.exports = __webpack_public_path__ + "img/offlineimg.f172bbda.png";